import { configureStore } from '@reduxjs/toolkit';
import { storeReducer } from './reducers/store-slice';
import { userReducer } from './reducers/user-slice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    store: storeReducer,
  },
});

export type AppState = ReturnType<typeof store.getState>;
